import { Tab, Tabs } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import SvgShuffle from "components/svg/SvgShuffle";
import SvgUsers from "components/svg/SvgUsers";
import SvgPackage from "components/svg/SvgPackage";
import ObjectTabProducts from "./Tabs/ObjectTabProducts";
import ObjectTabServices from "./Tabs/ObjectTabServices";
import ObjectTabOther from "./Tabs/ObjectTabOther";
import SvgEdit from "components/svg/SvgEdit";
import ObjectTabDescription from "./Tabs/ObjectTabDescription";
import ObjectTabCustomer from "./Tabs/ObjectTabCustomer";
import ObjectTabDocuments from "./Tabs/ObjectTabDocuments";
import ObjectTabEvents from "./Tabs/ObjectTabEvents";
import ObjectTabFiles from "./Tabs/ObjectTabFiles";
import { useObjectCard } from "./context/ObjectCardProvider";
import SvgMenu from "components/svg/SvgMenu";
import SpinnerBlock from "components/others/SpinnerBlock";
import SvgFile from "components/svg/SvgFile";
import ObjectDetails from "../ObjectDetails";
import SolarIcon from 'components/icons/SolarIcon';

const ObjectCardTabs = () => {
     
    const { t } = useTranslation(['Objects'])
    const { vObject, fetchObject, showSpinner, isEditLocked, onlySale } = useObjectCard();    
    return (
        <div>
            <SpinnerBlock show={showSpinner} onlyBlur={true}/>
            <div className="px-0 pt-2">
                <Tabs
                    variant="underline"
                    defaultActiveKey="documents"
                    className="mb-3 invoice-tab border-bottom">

                    <Tab eventKey="documents"
                        title={(<><SolarIcon name="file-earmark-text" className="me-1 fs-14" />{t('infoItems.objectDocuments')}</>) }>
                        <ObjectTabDocuments/>
                    </Tab>
                 
                    <Tab eventKey="products" 
                        title={(<><SvgPackage height={14} className="me-1"/>{t('infoItems.objectMaterials')}</>) }>
                        <ObjectTabProducts/>
                    </Tab>

                    {!onlySale ? (
                    <Tab eventKey="services"
                        title={(<><SvgUsers height={14} className="me-1"/>{t('infoItems.objectServices')}</>) }>
                        <ObjectTabServices/>
                    </Tab>
                    ) : null}

                    {!onlySale ? (
                    <Tab eventKey="other"
                        title={(<><SvgShuffle height={14} className="me-1"/>{t('infoItems.objectOther')}</>) }>
                        <ObjectTabOther/> 
                    </Tab>
                    ) : null}


                    <Tab eventKey="description"
                        title={(<><SvgEdit height={14} className="me-1"/>{t('infoItems.objectDescription')}</>) }>
                        <ObjectTabDescription/>
                    </Tab>

                    <Tab eventKey="customer"
                        title={(<><SolarIcon name="person-vcard" className="me-1 fs-14" />{t('infoItems.objectCustomer')}</>) }>
                        <ObjectTabCustomer/>
                    </Tab>

                    {!onlySale ? (
                    <Tab eventKey="specification"
                        title={(<><SolarIcon name="card-list" className="me-1 fs-14" />{t('infoItems.objectSpecification')}</>) }>
                        <ObjectDetails 
                            objectId={vObject?.object?.ID}
                            objectDetails={vObject?.object?.objectDelails}
                            readOnly={isEditLocked}
                            onSaved={fetchObject}
                        />
                    </Tab>
                    ) : null}
 
                    <Tab eventKey="files"
                        title={(<><SvgFile height={14} className="me-1"/>{t('infoItems.objectFiles')}</>) }>
                        <ObjectTabFiles/>
                    </Tab>

                    {vObject?.events?.length > 0 &&
                    (<Tab eventKey="events"
                        title={(<><SvgMenu height={14} className="me-1"/>{t('infoItems.objectEvents')}</>) }>
                        <ObjectTabEvents/>
                    </Tab>)}

                </Tabs>
            </div> 
        </div>
    )
}

export default ObjectCardTabs;